import React, { useCallback, useState } from 'react';
import dynamic from 'next/dynamic';

import { Button, WebpImageWithFallback } from '@husslehq/ui-library';

// Load carousel gallery dynamically
import { ImageListProps } from '../../components/ImageList/ImageList';
const ImageList = dynamic<ImageListProps>(() =>
  import('../../components/ImageList/ImageList').then((mod) => mod.ImageList),
);

import { track } from '../../services/analytics';

import styles from '../../components/MosaicMobile/MosaicMobile.module.scss';

export interface IMosaicImage {
  url: string;
  alt: string;
}

export interface IGalleryImage {
  original: string;
  thumbnail: string;
}

type Props = {
  firstImage: string;
  mobileFirstImage: string;
  galleryData: IGalleryImage[];
  gymName: string;
};

export const MosaicMobile: React.FC<Props> = ({ firstImage, mobileFirstImage, galleryData, gymName }) => {
  const [isShowModal, setIsShowModal] = useState(false);

  const handleViewGalleryClick = () => () => {
    document.body.classList.add('prevent-body-scrolling');
    setIsShowModal(true);
    track({
      event: 'gym_spa',
      category: 'Gym Details',
      action: 'Views Photos',
      label: 'all_photos',
    });
  };

  const handleCloseModal = useCallback(() => {
    document.body.classList.remove('prevent-body-scrolling');
    setIsShowModal(false);
    track({
      event: 'gym_spa',
      category: 'Gym Details',
      action: 'Views Photos',
      label: 'back_to_gym_details',
    });
  }, []);

  return (
    <div className={styles.mosaic}>
      <Button
        className={styles['mosaic__gallery-btn']}
        size="medium"
        level="outline"
        onClick={handleViewGalleryClick()}
      >
        All photos
      </Button>
      <div
        key={`mosaic_item_first`}
        className={`${styles['mosaic__item']} ${styles['mosaic__item--first']} ${styles['mosaic__item--clickable']}`}
        onClick={handleViewGalleryClick()}
      >
        <WebpImageWithFallback
          alt={'Photo of ' + gymName}
          className={styles['mosaic__image']}
          src={firstImage}
          mobileSrc={mobileFirstImage}
          loading="eager"
          width="385"
          height="265"
        />
      </div>
      <ImageList galleryData={galleryData} onClose={handleCloseModal} modalVisible={isShowModal} gymName={gymName} />
    </div>
  );
};

export { MosaicMobile as default };
